import styled from 'styled-components';

import BasicP from '../P';

const P = styled(BasicP)`
  margin-top: 20px;
  text-align: center;
`;

export default P;